/* ============================================================
   ds-tables.js  ·  Globales Tabellen-System, Mobile First
   Dogs Supreme, 13.08.2026

   Findet jede Tabelle im Inhaltsbereich, misst sie, waehlt die
   passende Darstellung und baut sie um. Wer eine ganz normale
   Tabelle schreibt, bekommt das Ergebnis ohne Zutun.

   DIE REGEL (erste greifende gewinnt)
     0  data-ds-tabelle am <table> gesetzt      -> Handbremse, gilt
     1  hoechstens 2 Spalten                     -> scroll (passt ohnehin)
     2  laengster Wert ueber der Fliesstext-      -> karten
        Schwelle (Artikel 45, Produkt 38)
     3  5 oder mehr Spalten, hoechstens 6 Zeilen -> karten
     4  5 oder mehr Spalten, mehr Zeilen         -> fokus,
        auf der Produktseite stattdessen karten
     5  sonst                                    -> scroll

   WARUM DIE PRODUKTSEITE ANDERS BEHANDELT WIRD
   Im Artikel liest jemand und vergleicht. Auf der Produktseite sucht
   jemand die eigene Zeile und will die Antwort sofort. Deshalb dort
   die niedrigere Schwelle zu Karten und kein Fokus-Modus: ein hinter
   einem Tippen verstecktes Merkmal kostet im Kaufmoment Vertrauen.
   Bei vielen Zeilen und wenigen schmalen Spalten bleibt es auch auf
   der Produktseite die kompakte Tabelle, weil zehn Groessen sonst
   zehn Karten ergeben und das Suchen laenger dauert als das Wischen.

   BARRIEREFREIHEIT
   Die Tabelle bleibt eine echte Tabelle im DOM. Im Karten-Modus
   setzt display:block die Semantik ausser Kraft, deshalb werden die
   Rollen hier explizit gesetzt. Der Scroll-Bereich bekommt
   role=region, einen Namen und tabindex=0, sonst kommt niemand ohne
   Maus an die Tabelle (WCAG 2.1.1, 4.1.2).
   ============================================================ */
(function () {
  'use strict';

  var SCHWELLE_TEXT_ARTIKEL = 45;   // Zeichen, ab denen eine Zelle Fliesstext ist
  var SCHWELLE_TEXT_PRODUKT = 38;
  var SCHWELLE_ZAHL = 14;           // bis hier gilt eine Spalte als Wertespalte
  var SCHWELLE_KURZ = 4;            // bis hier wird zentriert statt linksbuendig
  var SCHWELLE_LANG = 34;           // Wert bricht in der Karte unter das Merkmal
  var BEHAELTER = [
    '.ds-rte', '.rte', '.ds-apple-scope', '.product-single__description',
    '.collapsible-content__inner', '.shopify-policy__body', '.page-content',
    '[data-ds-tabellen]'
  ].join(',');

  function text(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  /* Breitenmessung erst, wenn das Layout wirklich steht. Ein einzelnes
     requestAnimationFrame misst zu frueh: die Tabelle ist dann noch so
     breit wie ihr Container, der Ueberlauf entsteht erst danach.
     Deshalb gestaffelt, zuletzt nach der Schriftladung. */
  function wennGemessen(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(fn); });
    setTimeout(fn, 250);
    if (document.readyState !== 'complete') window.addEventListener('load', fn, { once: true });
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(fn).catch(function () {});
    }
  }

  function kontext(tabelle) {
    if (tabelle.closest('.product-single__description, .product-block, [data-ds-size-chart-root], .product-template')) return 'produkt';
    var b = document.body;
    if (b.classList.contains('template-product') || /(^|\s)product/.test(b.getAttribute('data-template') || '')) return 'produkt';
    if (tabelle.closest('.ds-apple-scope, .ds-rte, article')) return 'artikel';
    if (b.classList.contains('template-article')) return 'artikel';
    return 'seite';
  }

  /* Misst die Tabelle: Spalten, Zeilen, laengster Wert, Laenge je Spalte. */
  function messen(tabelle) {
    var zeilen = Array.prototype.slice.call(tabelle.rows);
    if (!zeilen.length) return null;
    var kopfZeile = tabelle.tHead ? tabelle.tHead.rows[0] : zeilen[0];
    var koepfe = Array.prototype.map.call(kopfZeile.cells, text);
    var koerper = zeilen.filter(function (r) { return r !== kopfZeile; });
    var spalten = koepfe.length;
    var maxLaenge = 0;
    var proSpalte = new Array(spalten).fill(0);
    koerper.forEach(function (r) {
      Array.prototype.forEach.call(r.cells, function (c, i) {
        var l = text(c).length;
        if (l > maxLaenge) maxLaenge = l;
        if (i < spalten && l > proSpalte[i]) proSpalte[i] = l;
      });
    });
    return {
      spalten: spalten,
      zeilen: koerper.length,
      maxLaenge: maxLaenge,
      proSpalte: proSpalte,
      koepfe: koepfe,
      kopfZeile: kopfZeile,
      koerper: koerper
    };
  }

  function entscheiden(m, wo) {
    var schwelle = wo === 'produkt' ? SCHWELLE_TEXT_PRODUKT : SCHWELLE_TEXT_ARTIKEL;
    if (m.spalten <= 2) return 'scroll';
    if (m.maxLaenge > schwelle) return 'karten';
    if (m.spalten >= 5 && m.zeilen <= 6) return 'karten';
    if (m.spalten >= 5) return wo === 'produkt' ? 'karten' : 'fokus';
    return 'scroll';
  }

  /* Sorgt dafuer, dass die Tabelle in Huelle und Bahn steckt.

     Wichtig: Das Theme wickelt Tabellen im RTE-Bereich selbst in ein
     `div.table-wrapper` mit overflow:auto (theme.css.liquid), und
     ds-article.js legt im Artikel ein `.ds-table-wrapper` darum. Wer
     einen eigenen Wrapper aussen herum baut, sitzt ueber dem echten
     Scroll-Container: die eigene Bahn scrollt dann nie, Fortschritt,
     Tastaturfokus und die klebende erste Spalte laufen ins Leere,
     waehrend die Tabelle innen abgeschnitten wird. Deshalb wird immer
     der INNERSTE vorhandene Wrapper zur Bahn. */
  function einhuellen(tabelle) {
    var vorhanden = tabelle.closest('.ds-table-wrapper, .table-wrapper');
    var bahn, huelle;
    if (vorhanden) {
      bahn = vorhanden;
      bahn.classList.add('ds-tbl-bahn');
      huelle = vorhanden.closest('.ds-table-container, .ds-tbl-huelle');
      if (!huelle || huelle === vorhanden) {
        huelle = document.createElement('div');
        vorhanden.parentNode.insertBefore(huelle, vorhanden);
        huelle.appendChild(vorhanden);
      }
      huelle.classList.add('ds-tbl-huelle');
      /* Ein aeusserer Wrapper darf nicht ein zweites Mal scrollen,
         sonst entstehen zwei Scrollbereiche uebereinander. */
      var aussen = huelle.closest('.ds-table-wrapper');
      if (aussen) aussen.style.overflow = 'visible';
    } else {
      huelle = document.createElement('div');
      huelle.className = 'ds-tbl-huelle';
      bahn = document.createElement('div');
      bahn.className = 'ds-tbl-bahn';
      tabelle.parentNode.insertBefore(huelle, tabelle);
      huelle.appendChild(bahn);
      bahn.appendChild(tabelle);
    }
    return { huelle: huelle, bahn: bahn };
  }

  function benennen(tabelle, m) {
    var bild = tabelle.querySelector('caption');
    if (bild && text(bild)) return text(bild);
    var vor = tabelle.closest('.ds-tbl-huelle');
    vor = vor ? vor.previousElementSibling : null;
    for (var i = 0; i < 3 && vor; i++) {
      if (/^H[2-4]$/.test(vor.tagName) && text(vor)) return text(vor);
      vor = vor.previousElementSibling;
    }
    return m.koepfe.filter(Boolean).slice(0, 3).join(', ') || 'Tabelle';
  }

  /* Kopfzellen und Zeilenkoepfe nachziehen, wo im Quelltext nur td steht. */
  function semantikNachziehen(tabelle, m) {
    if (!tabelle.tHead && m.kopfZeile && m.kopfZeile.parentNode.tagName === 'TBODY') {
      var kopf = tabelle.createTHead();
      kopf.appendChild(m.kopfZeile);
    }
    /* Knoten umhaengen statt innerHTML kopieren: kein Reparsing, und
       nichts wird als HTML neu ausgewertet. */
    function umtopfen(alt, tag) {
      var neu = document.createElement(tag);
      if (alt.className) neu.className = alt.className;
      while (alt.firstChild) neu.appendChild(alt.firstChild);
      alt.parentNode.replaceChild(neu, alt);
      return neu;
    }
    Array.prototype.forEach.call(
      Array.prototype.slice.call(tabelle.querySelectorAll('thead td')),
      function (td) { umtopfen(td, 'th'); }
    );
    Array.prototype.forEach.call(tabelle.querySelectorAll('thead th'), function (th) {
      if (!th.getAttribute('scope')) th.setAttribute('scope', 'col');
    });
    Array.prototype.forEach.call(tabelle.tBodies, function (tb) {
      Array.prototype.forEach.call(tb.rows, function (r) {
        var erste = r.cells[0];
        if (!erste) return;
        if (erste.tagName === 'TD') erste = umtopfen(erste, 'th');
        if (!erste.getAttribute('scope')) erste.setAttribute('scope', 'row');
      });
    });
  }

  /* Rollen setzen, damit display:block im Karten-Modus die Semantik
     nicht zerstoert. */
  function rollenSetzen(tabelle) {
    tabelle.setAttribute('role', 'table');
    Array.prototype.forEach.call(tabelle.querySelectorAll('thead, tbody, tfoot'), function (g) {
      g.setAttribute('role', 'rowgroup');
    });
    Array.prototype.forEach.call(tabelle.rows, function (r) { r.setAttribute('role', 'row'); });
    Array.prototype.forEach.call(tabelle.querySelectorAll('th'), function (th) {
      th.setAttribute('role', th.getAttribute('scope') === 'row' ? 'rowheader' : 'columnheader');
    });
    Array.prototype.forEach.call(tabelle.querySelectorAll('td'), function (td) {
      td.setAttribute('role', 'cell');
    });
  }

  /* Sichtbares Merkmal in die Zelle, als aria-hidden, damit
     Vorleseprogramme es nicht doppelt zum Spaltenkopf lesen. */
  function labelSetzen(tabelle, m) {
    Array.prototype.forEach.call(tabelle.tBodies, function (tb) {
      Array.prototype.forEach.call(tb.rows, function (r) {
        Array.prototype.forEach.call(r.cells, function (c, i) {
          if (c.querySelector('.ds-tbl-label')) return;
          var wert = document.createElement('span');
          wert.className = 'ds-tbl-wert';
          while (c.firstChild) wert.appendChild(c.firstChild);
          var label = document.createElement('span');
          label.className = 'ds-tbl-label';
          label.setAttribute('aria-hidden', 'true');
          label.textContent = m.koepfe[i] || '';
          c.appendChild(label);
          c.appendChild(wert);
          if (i > 0 && text(wert).length > SCHWELLE_LANG) c.classList.add('ds-tbl-lang');
        });
      });
    });
  }

  /* ---------- Spaltenraster ----------

     Das Kernproblem jeder Tabelle mit Text: bei `table-layout: auto`
     bestimmt der BREITESTE Inhalt einer Spalte ihre Breite, und das ist
     fast immer die Ueberschrift. "Empfohlene Leinengroesse" zieht die
     Spalte dann auf 94 px, obwohl darunter nur ein "S" steht. Ergebnis
     ist toter Weissraum und ungleicher Rhythmus zwischen den Spalten.
     Den Text zu kuerzen loest das nur fuer genau diese eine Tabelle.

     Deshalb rechnet dieses System die Spaltenbreiten selbst aus:
       - Werte zaehlen voll,
       - von der Ueberschrift zaehlt nur ihr LAENGSTES WORT, der Rest
         darf umbrechen,
       - was uebrig bleibt, wird gleichmaessig auf alle Spalten verteilt,
         damit ueberall gleich viel Luft steht.
     Das Ergebnis steht als colgroup in der Tabelle, mit table-layout:
     fixed, damit der Browser sich daran haelt. */

  var MESSER = null;
  function textbreite(s, schrift) {
    if (!MESSER) {
      var c = document.createElement('canvas');
      MESSER = c.getContext ? c.getContext('2d') : null;
    }
    if (!MESSER) return String(s).length * 7;      // Notnagel ohne Canvas
    MESSER.font = schrift;
    return MESSER.measureText(String(s)).width;
  }

  function schriftVon(el) {
    var cs = getComputedStyle(el);
    return cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' / ' +
           cs.lineHeight + ' ' + cs.fontFamily;
  }

  function zaehleLange(m) {
    var n = 0;
    m.koepfe.forEach(function (k) { if (String(k).length >= 9) n++; });
    return n || 1;
  }

  /* Wie viel Breite geben die Ueberschriften her, wenn sie an
     Silbengrenzen umbrechen duerfen? Grob: gut ein Drittel des laengsten
     Wortes je Kopf ab neun Zeichen. */
  function luftImKopf(m, schrift) {
    var luft = 0;
    m.koepfe.forEach(function (k) {
      var kopf = String(k || '');
      if (kopf.length < 9) return;
      var wort = kopf.split(/\s+/).reduce(function (a, w) { return w.length > a.length ? w : a; }, '');
      if (wort.length < 9) return;
      luft += textbreite(wort, schrift) * 0.38;
    });
    return luft;
  }

  function huelleVon(tabelle) {
    return tabelle.closest('.ds-tbl-huelle') || document.createElement('div');
  }

  /* Nachtraeglicher Wechsel auf Karten, wenn das Raster zeigt, dass die
     Tabelle sonst vielfach ueber den Bildschirm hinausliefe. */
  function aufKartenUmstellen(tabelle, m) {
    var huelle = huelleVon(tabelle);
    var bahn = huelle.querySelector('.ds-tbl-bahn');
    var col = tabelle.querySelector('colgroup[data-ds-raster]');
    if (col) col.parentNode.removeChild(col);
    tabelle.removeAttribute('data-ds-raster');
    tabelle.removeAttribute('data-ds-kopftrennung');
    tabelle.style.width = '';
    tabelle.style.minWidth = '';
    huelle.setAttribute('data-ds-modus', 'karten');
    huelle.setAttribute('data-ds-nachkorrektur', 'ja');
    tabelle.setAttribute('data-ds-fertig', 'karten');
    if (bahn) {
      bahn.removeAttribute('role');
      bahn.removeAttribute('tabindex');
    }
    var leiste = huelle.querySelector('.ds-tbl-fortschritt');
    if (leiste) leiste.style.display = 'none';
    rollenSetzen(tabelle);
    labelSetzen(tabelle, m);
  }

  function spaltenRaster(tabelle, m, bahn) {
    var kopfZelle = tabelle.tHead && tabelle.tHead.rows[0] && tabelle.tHead.rows[0].cells[0];
    var wertZelle = tabelle.tBodies[0] && tabelle.tBodies[0].rows[0] && tabelle.tBodies[0].rows[0].cells[0];
    if (!kopfZelle || !wertZelle) return;

    var kopfSchrift = schriftVon(kopfZelle);
    var wertSchrift = schriftVon(wertZelle);
    var cs = getComputedStyle(wertZelle);
    var polster = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);

    var wertBreiten = [];
    var soll = m.koepfe.map(function (kopf, i) {
      // Von der Ueberschrift zaehlt nur das laengste Wort.
      var laengstesWort = String(kopf).split(/\s+/).reduce(function (a, w) {
        return textbreite(w, kopfSchrift) > textbreite(a, kopfSchrift) ? w : a;
      }, '');
      var breiteKopf = textbreite(laengstesWort, kopfSchrift);
      var breiteWerte = 0;
      m.koerper.forEach(function (r) {
        var z = r.cells[i];
        if (!z) return;
        var b = textbreite(text(z), wertSchrift);
        if (b > breiteWerte) breiteWerte = b;
      });
      wertBreiten[i] = Math.ceil(breiteWerte + polster + 2);
      return Math.ceil(Math.max(breiteKopf, breiteWerte) + polster + 2);
    });

    var summe = soll.reduce(function (a, b) { return a + b; }, 0);
    /* Verdeckt (0 px): nicht rastern. Der ResizeObserver auf der Bahn
       ruft erneut, sobald sie eine echte Breite hat. */
    if (bahn.clientWidth < 2) return;
    var platz = bahn.clientWidth - 2;
    var col = document.createElement('colgroup');

    if (summe <= platz) {
      /* Es ist Luft da: den Ueberschuss zu gleichen Teilen verteilen, damit
         zwischen allen Spalten gleich viel Abstand entsteht. */
      var extra = (platz - summe) / soll.length;
      soll = soll.map(function (b) { return b + extra; });
      var gesamt = soll.reduce(function (a, b) { return a + b; }, 0);
      soll.forEach(function (b) {
        var c = document.createElement('col');
        c.style.width = (b / gesamt * 100).toFixed(3) + '%';
        col.appendChild(c);
      });
      tabelle.style.width = '100%';
      tabelle.style.minWidth = '0';
    } else if (summe - platz <= luftImKopf(m, kopfSchrift)) {
      /* Es fehlt nur so viel, wie die Ueberschriften an Silbengrenzen
         hergeben. Statt den Text zu kuerzen, darf der Kopf hier trennen:
         "Leinen-groesse" statt einer zu breiten Spalte. Das ist normale
         Typografie und aendert kein Wort. Ausdruecklich nur in diesem
         Engpass, sonst bliebe ein kurzes Wort wie "Leine" als "Lei-ne"
         stehen, was schlechter aussieht als die breite Spalte. */
      tabelle.setAttribute('data-ds-kopftrennung', 'ja');
      var knapp = soll.map(function (b, i) {
        var kopf = String(m.koepfe[i] || '');
        if (kopf.length < 9) return b;
        /* Untergrenze ist die Breite der WERTE, nicht ein fester Bruchteil.
           Sonst wird eine Spalte mit langem Kopf und kurzem Wert so eng,
           dass der Wert umbricht: "Preis je Kilo" ueber "10,95 EUR" ergab
           den Preis auf drei Zeilen. Gestaucht wird nur der Platz, den
           allein die Ueberschrift beansprucht. */
        return Math.max(b - (summe - platz) / zaehleLange(m), wertBreiten[i] || b * 0.62);
      });
      var g2 = knapp.reduce(function (a, b) { return a + b; }, 0);
      knapp.forEach(function (b) {
        var c = document.createElement('col');
        c.style.width = (b / g2 * 100).toFixed(3) + '%';
        col.appendChild(c);
      });
      tabelle.style.width = '100%';
      tabelle.style.minWidth = '0';
    } else if (summe / platz > 1.6 && huelleVon(tabelle).getAttribute('data-ds-modus') === 'scroll') {
      /* Die Entscheidung war falsch. Zeichen zu zaehlen reicht nicht: vier
         Spalten mit je vierzig Zeichen bleiben unter der Fliesstext-Schwelle
         und ergeben trotzdem die dreifache Bildschirmbreite. Erst hier, mit
         den echten Breiten, ist das messbar. Statt den Kunden dreimal wischen
         zu lassen, wird auf Karten umgestellt. */
      aufKartenUmstellen(tabelle, m);
      return;
    } else {
      /* Zu eng: die Sollbreiten bleiben stehen, die Tabelle scrollt. */
      soll.forEach(function (b) {
        var c = document.createElement('col');
        c.style.width = b + 'px';
        col.appendChild(c);
      });
      tabelle.style.width = summe + 'px';
      tabelle.style.minWidth = summe + 'px';
    }
    var altCol = tabelle.querySelector('colgroup[data-ds-raster]');
    if (altCol) altCol.parentNode.removeChild(altCol);
    col.setAttribute('data-ds-raster', '');
    tabelle.insertBefore(col, tabelle.firstChild);
    /* Als Attribut, nicht als Inline-Style: das Grundgeruest setzt
       table-layout mit !important, und ein Inline-Style verliert
       dagegen. Ueber das Attribut greift die passende CSS-Regel. */
    tabelle.setAttribute('data-ds-raster', 'ja');
  }

  function spaltenKlassen(tabelle, m) {
    /* Drei Sorten Spalte, jede mit eigener Ausrichtung:
       kurz  bis 4 Zeichen (Groessen, Kuerzel)  -> zentriert
       zahl  bis 14 Zeichen (Werte, Bereiche)   -> linksbuendig, nicht umbrechend
       txt   alles darueber                     -> linksbuendig mit Umbruch
       Die erste Spalte wird mitbewertet, gerade dort stehen die Groessen. */
    var klasse = m.proSpalte.map(function (l, i) {
      var kopf = (m.koepfe[i] || '').length;
      if (l <= SCHWELLE_KURZ && kopf > l) return 'ds-tbl-kurz';
      return l <= SCHWELLE_ZAHL ? 'ds-tbl-zahl' : 'ds-tbl-txt';
    });
    Array.prototype.forEach.call(tabelle.rows, function (r) {
      Array.prototype.forEach.call(r.cells, function (c, i) {
        if (!klasse[i]) return;
        /* Auch die erste Spalte. Sie war frueher ausgenommen, damit der
           Zeilenkopf linksbuendig bleibt. Das ergab aber genau den Fehler,
           den man sofort sieht: zwei Spalten mit identischem Inhalt
           ("Rind, Huhn, Pute") standen unterschiedlich ausgerichtet
           nebeneinander, weil nur die zweite ihre Klasse bekam. */
        c.classList.add(klasse[i]);
      });
    });
  }

  function fortschritt(huelle, bahn) {
    var rand = document.createElement('div');
    rand.className = 'ds-tbl-rand';
    huelle.appendChild(rand);

    var leiste = document.createElement('div');
    leiste.className = 'ds-tbl-fortschritt';
    leiste.innerHTML = '<span class="ds-tbl-pfeil" aria-hidden="true">↔</span>' +
      '<span class="ds-tbl-schiene"><i class="ds-tbl-reiter"></i></span>' +
      '<span class="ds-tbl-stand"></span>';
    huelle.appendChild(leiste);

    var reiter = leiste.querySelector('.ds-tbl-reiter');
    var stand = leiste.querySelector('.ds-tbl-stand');

    function auffrischen() {
      var rest = bahn.scrollWidth - bahn.clientWidth;
      if (rest <= 2) {
        leiste.style.display = 'none';
        huelle.setAttribute('data-ds-ende', 'ja');
        return;
      }
      leiste.style.display = 'flex';
      var anteil = bahn.scrollLeft / rest;
      var sicht = Math.max(bahn.clientWidth / bahn.scrollWidth, 0.12);
      reiter.style.width = (sicht * 100) + '%';
      reiter.style.marginLeft = (anteil * (100 - sicht * 100)) + '%';
      stand.textContent = Math.round(anteil * 100) + ' %';
      huelle.setAttribute('data-ds-ende', anteil > 0.98 ? 'ja' : 'nein');
    }
    bahn.addEventListener('scroll', auffrischen, { passive: true });
    window.addEventListener('resize', auffrischen, { passive: true });
    if (window.ResizeObserver) {
      var beob = new ResizeObserver(auffrischen);
      beob.observe(bahn);
      if (bahn.firstElementChild) beob.observe(bahn.firstElementChild);
    }
    wennGemessen(auffrischen);
  }

  function fokusBauen(huelle, tabelle, m) {
    var waehler = document.createElement('div');
    waehler.className = 'ds-tbl-waehler';
    waehler.setAttribute('role', 'group');
    waehler.setAttribute('aria-label', 'Merkmal waehlen');
    huelle.insertBefore(waehler, huelle.firstChild);

    function zeigen(nr) {
      Array.prototype.forEach.call(tabelle.rows, function (r) {
        Array.prototype.forEach.call(r.cells, function (c, i) {
          c.classList.toggle('ds-tbl-aus', i !== 0 && i !== nr);
        });
      });
      Array.prototype.forEach.call(waehler.children, function (b) {
        b.setAttribute('aria-pressed', String(Number(b.dataset.sp) === nr));
      });
    }
    m.koepfe.forEach(function (k, i) {
      if (i === 0) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.sp = String(i);
      b.textContent = k;
      b.addEventListener('click', function () { zeigen(i); });
      waehler.appendChild(b);
    });
    zeigen(1);
  }

  /* Eine verdeckte Tabelle (geschlossenes Panel, Akkordeon, Reiter) hat
     keine Breite. Wer sie dann schon entscheidet und rastert, rechnet mit
     0 px: Chromium setzt beim Oeffnen ein viel zu breites Raster, WebKit
     rechnet gar nicht nach (VG-2610-CAFFZ, iPhone 25.10.2026). Deshalb
     wartet sie, bis sie sichtbar wird, und laeuft dann einmal durch. */
  function sichtbar(tabelle) {
    return tabelle.getClientRects().length > 0 && tabelle.offsetWidth > 0;
  }

  function wartenBisSichtbar(tabelle) {
    if (tabelle.dsWartet) return;
    tabelle.dsWartet = true;
    tabelle.setAttribute('data-ds-wartet', 'ja');
    var los = function () {
      if (!sichtbar(tabelle)) return false;
      tabelle.dsWartet = false;
      tabelle.removeAttribute('data-ds-wartet');
      aufbereiten(tabelle);
      return true;
    };
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { if (los()) ro.disconnect(); });
      ro.observe(tabelle);
    } else {
      /* Ohne ResizeObserver beim naechsten Klick oder Tippen nachsehen. */
      var nachKlick = function () {
        setTimeout(function () {
          if (los()) document.removeEventListener('click', nachKlick, true);
        }, 60);
      };
      document.addEventListener('click', nachKlick, true);
    }
  }

  function aufbereiten(tabelle) {
    if (tabelle.hasAttribute('data-ds-fertig')) return;
    if (tabelle.dsWartet) return;
    /* Eine innerHTML-Kopie erbt das Attribut, aber nicht den Beobachter:
       den geerbten Vermerk streichen, wartenBisSichtbar setzt ihn bei
       Bedarf neu. */
    tabelle.removeAttribute('data-ds-wartet');
    if (tabelle.closest('table')  !== tabelle) { /* verschachtelt */ }
    if (tabelle.parentNode && tabelle.parentNode.closest('table')) {
      tabelle.setAttribute('data-ds-fertig', 'verschachtelt');
      return;
    }
    var m = messen(tabelle);
    if (!m || m.spalten < 2 || !m.koerper.length) {
      tabelle.setAttribute('data-ds-fertig', 'uebersprungen');
      return;
    }
    if (!sichtbar(tabelle)) {
      wartenBisSichtbar(tabelle);
      return;
    }

    var wo = kontext(tabelle);
    var handbremse = tabelle.getAttribute('data-ds-tabelle');
    var modus = (handbremse === 'karten' || handbremse === 'scroll' || handbremse === 'fokus')
      ? handbremse : entscheiden(m, wo);

    semantikNachziehen(tabelle, m);
    m = messen(tabelle) || m;

    var teile = einhuellen(tabelle);
    var huelle = teile.huelle, bahn = teile.bahn;
    huelle.setAttribute('data-ds-modus', modus);
    huelle.setAttribute('data-ds-kontext', wo);

    spaltenKlassen(tabelle, m);
    /* Kein Raster im Fokus-Modus: dort blendet die Chip-Leiste Spalten aus,
       die colgroup wuerde ihnen die Breite trotzdem reservieren und die
       Tabelle bliebe so breit wie mit allen Spalten. */
    if (modus === 'scroll') {
      wennGemessen(function () { spaltenRaster(tabelle, m, bahn); });
      if (window.ResizeObserver) {
        var rb = null;
        new ResizeObserver(function () {
          clearTimeout(rb);
          rb = setTimeout(function () { spaltenRaster(tabelle, m, bahn); }, 120);
        }).observe(bahn);
      }
    }

    /* role=region und tabindex nur, solange die Bahn wirklich
       scrollbar ist. Ein Tabstopp ohne Scrollbarkeit waere ein
       leerer Halt fuer Tastaturnutzer, ein fehlender waere eine
       unerreichbare Tabelle. Deshalb an die Breite gekoppelt. */
    var name = benennen(tabelle, m);
    (function pflegeRegion() {
      function pruefen() {
        var rollbar = bahn.scrollWidth > bahn.clientWidth + 2;
        if (rollbar) {
          bahn.setAttribute('role', 'region');
          bahn.setAttribute('aria-label', name);
          bahn.setAttribute('tabindex', '0');
        } else {
          bahn.removeAttribute('role');
          bahn.removeAttribute('tabindex');
        }
      }
      /* Die Tabelle beobachten, nicht die Bahn: deren clientWidth
         aendert sich nie, die Tabellenbreite schon (Schriftladung,
         Akkordeon, Drehung). */
      if (window.ResizeObserver) {
        var b = new ResizeObserver(pruefen);
        b.observe(tabelle);
        b.observe(bahn);
      }
      window.addEventListener('resize', pruefen, { passive: true });
      wennGemessen(pruefen);
    })();

    if (modus === 'karten') {
      rollenSetzen(tabelle);
      labelSetzen(tabelle, m);
    } else if (modus === 'fokus') {
      fokusBauen(huelle, tabelle, m);
      fortschritt(huelle, bahn);
    } else {
      fortschritt(huelle, bahn);
    }

    tabelle.setAttribute('data-ds-fertig', modus);
  }

  function lauf(wurzel) {
    var bereich = (wurzel || document).querySelectorAll(BEHAELTER);
    var gesehen = [];
    Array.prototype.forEach.call(bereich, function (b) {
      Array.prototype.forEach.call(b.querySelectorAll('table'), function (t) {
        if (gesehen.indexOf(t) === -1) { gesehen.push(t); aufbereiten(t); }
      });
    });
    /* Das Theme oeffnet Panels per innerHTML-Kopie (tool-tip in theme.js).
       Die Kopie liegt ausserhalb der Behaelter oben und traegt nur das
       Attribut data-ds-wartet, nicht den Beobachter. Deshalb wartende
       Tabellen ueberall mitnehmen. */
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('table[data-ds-wartet]'), function (t) {
      if (gesehen.indexOf(t) === -1) { gesehen.push(t); aufbereiten(t); }
    });
  }

  function start() {
    lauf(document);
    /* Nachgeladene Inhalte: Akkordeon, Schnellansicht, App-Blocks. */
    if (window.MutationObserver) {
      var wartend = false;
      new MutationObserver(function (eintraege) {
        if (wartend) return;
        var neu = eintraege.some(function (e) {
          return Array.prototype.some.call(e.addedNodes, function (n) {
            return n.nodeType === 1 && (n.tagName === 'TABLE' || (n.querySelector && n.querySelector('table')));
          });
        });
        if (!neu) return;
        wartend = true;
        requestAnimationFrame(function () { wartend = false; lauf(document); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.dsTabellen = { lauf: lauf, entscheiden: entscheiden, messen: messen };
})();
